import { render, staticRenderFns } from "./purchaseRefundList.vue?vue&type=template&id=2e7d95e4&scoped=true"
import script from "./purchaseRefundList.vue?vue&type=script&lang=js"
export * from "./purchaseRefundList.vue?vue&type=script&lang=js"
import style0 from "./purchaseRefundList.vue?vue&type=style&index=0&id=2e7d95e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d95e4",
  null
  
)

export default component.exports